import { Component,HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../login-service';

@Component({
  selector: 'app-bidacollabo',
  templateUrl: './bidacollabo.component.html',
  styleUrls: ['./bidacollabo.component.scss']
})
export class BidacollaboComponent implements OnInit {
  tempcollaboList: any;
  presentCollabos: any;
  tempcol: any[];
  searchText: any;
  actorDetails: any;
  tempcollabos: any=[];
  RowCollaboDetils: any;
  servicechargeList: any;
  filteredservicecharge: any;
  ServiceCharge: any;
  selectedgroups  = [];
  selectedSkillsListid: any[];
  CheckedActorID: any;
  actorSelected: any;
  checkEnable: boolean;
  tabName: any;
  tabtype: any;
  IsProposal: boolean=false;
  ProposalDescription: any;
  BidAmount: any;
  totalHours: any;
  hoursEstimated: any;
  displayinput: boolean;
  filename: any;
  imagefile: void;
  imageservice: any;
  proposalfilepath: any;
  userID: any;
  IsTotalAmout:boolean=false;
  lblTotalAmout:number;
  CollaboPraposalDetails: any;
  submitproposalfile: any;
  bidRowID: any;
  savebidJson: any;
  dragAreaClass: string;
  showtopsearch: boolean=false;
  constructor(private loginService:LoginService,private router:Router) { }

  ngOnInit(): void {
    this.tempcol=this.tempcollabos;
    this.Getcollabos();
    this.GetServicecharge();
    this.dragAreaClass = "dragarea";
  }
  Getcollabos(){
    this.loginService.GetCollabos(1).subscribe(data=>
      {
          data = JSON.parse(data['_body']);
          this.tempcollaboList=JSON.parse(JSON.stringify(data));
          this.presentCollabos=this.tempcollaboList.filter(x=>x.status==1 || x.status==2);
          this.loginService.GetCollaboActorDetails().subscribe(data1=>
            {
              data1=JSON.parse(data1['_body']);
              this.actorDetails=JSON.parse(JSON.stringify(data1));
            for(var i=0;i<this.presentCollabos.length;i++){
              var actors=this.actorDetails.filter(x=>x.CollaboId==this.presentCollabos[i].id)
              this.tempcollabos.push({
                id:this.presentCollabos[i].id,
                title:this.presentCollabos[i].title,
                actors:actors,
                pay_type:this.presentCollabos[i].pay_type,
                description: this.presentCollabos[i].description,
                skillname:this.presentCollabos[i].skillname,
                createddate:this.presentCollabos[i].createddate.split("T")[0],
                status:this.presentCollabos[i].statusname,
                Specificbudget:this.presentCollabos[i].estimated_time,
                start_date:this.presentCollabos[i].start_date,
                end_date: this.presentCollabos[i].end_date,
                region: this.presentCollabos[i].region,
              })
            }
            var filterArray = this.tempcollabos.reduce((accumalator, current) => {
              if(!accumalator.some(item => item.id === current.id )) {
                accumalator.push(current);
              }
              return accumalator;
          },[]);
          this.tempcollabos=filterArray;
      });
    })
    }
    @HostListener("dragover", ["$event"]) onDragOver(event: any) {
      this.dragAreaClass = "droparea";
      event.preventDefault();
    }
    @HostListener("dragenter", ["$event"]) onDragEnter(event: any) {
      this.dragAreaClass = "droparea";
      event.preventDefault();
    }
    @HostListener("dragend", ["$event"]) onDragEnd(event: any) {
      this.dragAreaClass = "dragarea";
      event.preventDefault();
    }
    @HostListener("dragleave", ["$event"]) onDragLeave(event: any) {
      this.dragAreaClass = "dragarea";
      event.preventDefault();
    }
    @HostListener("drop", ["$event"]) onDrop(event: any) {
      this.dragAreaClass = "dragarea";
      event.preventDefault();
      event.stopPropagation();
      if (event.dataTransfer.files) {
        this.displayinput=true;
        let files: FileList = event.dataTransfer.files;
        
        this.filename=files[0].name
       
         if(files[0].type=="application/pdf"||"application/doc")
         {
        this.imagefile = this.loginService.filechange2(files[0],files.length,this.userID,"submitproposal");
       
        this.imageservice.ImageUplode1.subscribe( );
        this.proposalfilepath='Images/submitproposal/'+this.userID+'/'+this.filename
        
        localStorage.setItem('proposalfilepath',this.proposalfilepath);
         }
         else if(files[0].type=="image/png"||"image/jpg"||"image/jpeg")
         {
          this.imagefile = this.loginService.filechange2(files[0],files.length,this.userID,"submitproposal");
          
          this.imageservice.ImageUplode.subscribe();
          this.proposalfilepath='Images/submitproposal/'+this.userID+'/'+this.filename
      
      localStorage.setItem('proposalfilepath',this.proposalfilepath);
          
         }
      }
    }

    Searchtext(){
      this.Getcollabos();
      this.tempcol=[];
      this.tempcol=this.tempcollabos;
      console.log(this.tempcol);
     let tempCompany = this.tempcol.filter(
       (item) => {
         for(var i=0;i<item.actors.length;i++){
         return (
           (item.title !== null && item.title.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)|| (item.region !== null && item.region.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)||(item.createddate !== null && item.createddate.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)||(item.skillname !== null && item.skillname.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)||
           (item.actors[i].name !== null && item.actors[i].name.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
         );
         }
       }
    
     );
     this.tempcol = tempCompany;
     if(this.tempcol.length>0&&this.searchText!="")
     {this.showtopsearch=true;}
     else{this.showtopsearch=false}
     
    }
    calculateDiff(sentDate,enddate) {
      var date1:any = new Date(sentDate);
      var date2:any = new Date(enddate);
      var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));
  
      return diffDays;
  }
  GetServicecharge(){
      
    this.loginService.Getservicecharge(3).subscribe(data=>
      {
        data = JSON.parse(data['_body']);
        this.servicechargeList = data;
      });
   
 } 
  ChangeUnitSubGrp(element, event, i,row) {
    this.selectedSkillsListid=[];
    this.GetServicecharge();
     if(this.servicechargeList.length>0)
     {
     this.filteredservicecharge=this.servicechargeList.filter(x=>(parseInt(x.Frombudget)<=parseInt(row.Specificbudget))&&(parseInt(x.Tobudget)>=parseInt(row.Specificbudget)))
   this.ServiceCharge=this.filteredservicecharge[0].Servicecharge
     }
     else{
      this.ServiceCharge=0
     }
        element.check = event.checked;
        this.RowCollaboDetils=row;
        if (!event.checked) {
          const index = this.selectedgroups.indexOf(element);
          this.selectedgroups.splice(index, 1);
          this.checkEnable = false;
        } else {
          this.selectedgroups.push(element);
          this.checkEnable = true;
        }
        if (this.selectedgroups.length === 0) {
          this.checkEnable = false;
        }
            for(let i=0;i<this.selectedgroups.length;i++)
          {
             this.selectedSkillsListid=this.selectedgroups[i].ActorId;
            this.CheckedActorID=element.ActorId;
              this.actorSelected[i]=event.checked;
          }
      }
      nextPrev(tabname)
      {
  this.tabName=tabname;
  this.tabtype=tabname;
      }
      CancelCollabo(){
        this.IsProposal=false;
        this.ProposalDescription="";
        this.BidAmount="";
        this.ServiceCharge="";
        this.totalHours="";
        this.hoursEstimated="";

    }
    fileChange(input) {
      this.displayinput=true;
      this.filename=input.files[0].name
      this.imagefile = this.loginService.filechange1(input,"submitproposal",this.userID);
      
      this.imageservice.ImageUplode1.subscribe();
      this.proposalfilepath='Images/submitproposal/'+this.userID+'/'+this.filename
      
      localStorage.setItem('proposalfilepath',this.proposalfilepath);
      
    }
    calculateTotalAmount(){
      if(this.BidAmount !== undefined && this.ServiceCharge!==undefined){
          this.lblTotalAmout = parseInt(this.BidAmount)-(parseInt(this.BidAmount)*parseInt(this.ServiceCharge)/100);
          this.IsTotalAmout=true;
        }
  }
  SubmitPraposal(row,tabType,actorid){
    this.tabtype=tabType;
this.IsProposal=true;
this.CollaboPraposalDetails=row;

  }
  saveProposal(cid){
    this.submitproposalfile=localStorage.getItem('proposalfilepath')
    localStorage.setItem('BidSubmitted','true');
    this.savebidJson={
      bidRowID:this.bidRowID,
      colaboId:cid,
      userid:this.userID,
      description:this.ProposalDescription,
      bidsAmout:this.BidAmount,
      serviceCharge:this.ServiceCharge,
      toalHours:this.totalHours,
      hoursEstimated:this.hoursEstimated,
      createdbyparm:'Admin',
      updatedbyparm:'Admin',
      proposalfilepath:this.submitproposalfile,
      ActorID:this.CheckedActorID,
  statusparm:"2",
  bidstatus:'InProgress'  ,
  actorid:this.CheckedActorID  
  }
  this.savebidJson=JSON.stringify(this.savebidJson)
  localStorage.setItem('Bidjson',this.savebidJson)
  this.router.navigateByUrl('/register');
  }
    
}
